<app-inner-box>
  <app-subpage-header title="Lagerhäuser"></app-subpage-header>
  <app-list #listComponent></app-list>
</app-inner-box>

